import $ from 'jquery';

$('.js-table').each(function () {
	$('.js-table-btn', this).on('click', function () {
		$(this).toggleClass('is-open');
		if ($(this).hasClass('is-open')) {
			$('span', this).text('閉じる');
		} else {
			$('span', this).text('内訳を見る');
		}
		$(this).closest('.js-table-row').toggleClass('is-open');
		$(this).closest('.js-table').find('.js-table-content').slideToggle();
	});
});
